import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import LookRoomPreset from "./lookRoomPreset";
import MaterialSpinner from "../../ui/materialSpinner";

const LookRoomsMain = (props) => {

  const {bvPresets, visualizersLoadedLength, hideOverlay} = props;

  if (!visualizersLoadedLength) {
    return (
      <div className="ll-main">
        <MaterialSpinner/>
      </div>
    )
  }

  // console.log("bvPresets", bvPresets);

  return (
    <div className="ll-main">
      <ul className="ll-layouts ll-rooms">
        {bvPresets.map((roomPreset, lookIndex) => {
          return <LookRoomPreset key={lookIndex} roomPreset={roomPreset} hideOverlay={hideOverlay}/>
        })}
      </ul>
    </div>
  )
};

LookRoomsMain.propTypes = {
  hideOverlay: PropTypes.func,
}

const mapStateToProps = (store) => {
  const {visualizersLoaded} = store.serverState;
  return {
    bvPresets: store.bathroomVisualizerState.bvPresets,
    visualizersLoadedLength: visualizersLoaded.length
  };
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(LookRoomsMain)

